import styled, { keyframes } from "styled-components";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Message, Button, Icon, Modal, Header } from "semantic-ui-react";
import { Link, useLocation } from "react-router-dom";
// import Select from "react-select";
import { CSVLink, CSVDownload } from "react-csv";

import Upload from "./Upload";
import List from "./List";
import UpdateEmployeeRecordDetails from "./Details";
import { BasicErrorMessage } from "utilities/ErrorMessages";

// import { saveAs } from "file-saver";

import ContactBreadcrumb from "../ContactBreadcrumb";

import {
	LOAD_TEAMS,
	PULL_ORGANIZATION,
	SG_GET_FILE_UPLOADS,
	SG_GET_SURVEY_STRUCTURES,
	CLEAR_ERRORS,
	SG_GET_EMPLOYEE_RECORD_VALUE,
	SG_VALIDATE_ORG_EMP_EMAIL,
	CLOSE_FILE_UPLOAD,
} from "constants/actions";

const AllPageOptions = [
	{
		id: 1,
		name: "Contact update record",
	},
	{
		id: 2,
		name: "View Details",
	},
	{
		id: 3,
		name: "Update contacts",
	},
	{
		id: 4,
		name: "Preview update",
	},
];

const FileUploads = () => {
	const dispatch = useDispatch();
	const [organizationId, setOrganizationId] = useState(false);
	const [employee, setEmployee] = React.useState(false);

	const [showReportId, setShowReportId] = useState(false);
	const [showErrors, setShowErrors] = React.useState(false);
	const [fetchAgain, setFetchAgain] = useState(0);
	const [deletedRecord, setDeletedRecord] = useState(0);
	const [createEdit, setCreateEdit] = useState(0);
	const [showPage, setShowPage] = useState(AllPageOptions[0]);

	const [employeeRecValue, setEmployeeRecValue] = useState([]);

	const EmployeeId = useSelector(
		(state) => Number(state.auth?.employee_id),
		shallowEqual
	);
	const AmbassadorId = useSelector(
		(state) => Number(state.auth?.ambassador_id),
		shallowEqual
	);

	const {
		get_auth,
		get_selectedOrg,
		get_employee,
		get_survey_structure,
		get_errors,
		get_employee_record_value,
	} = useSelector(
		(state) => ({
			get_errors: state.errors,
			get_auth: state.auth,
			get_employee: state.employees,
			get_selectedOrg: state.selectedOrg,
			get_survey_structure: state.surveystructure.survey_structure,
			get_employee_record_value: state.employee_record_value.employee_record_value,
		}),
		shallowEqual
	);

	useEffect(() => {
		const _empVal = []
		_empVal.push("email")
		_empVal.push(...get_employee_record_value.map(ev => ev.external_name))	
		setEmployeeRecValue(_empVal)
	  }, [get_employee_record_value]);

	  useEffect(() => {
		if (organizationId) {
			dispatch({
				type: SG_VALIDATE_ORG_EMP_EMAIL,
				payload: `organization-id=${organizationId}`,
			});
		}
	}, [dispatch, organizationId])

	useEffect(() => {
		// Run! Like go get some data from an API.
		// dispatch({ type: SG_GET_MOODS });
		if (Number(AmbassadorId) > 0) {
			if (organizationId) {
				dispatch({
					type: LOAD_TEAMS,
					payload: `organization=${organizationId}`,
				});
				dispatch({
					type: PULL_ORGANIZATION,
					payload: { id: organizationId },
				});
				dispatch({
					type: SG_GET_FILE_UPLOADS,
					payload: `file_type=3&organization=${organizationId}`,
				});
				dispatch({
					type: SG_GET_SURVEY_STRUCTURES,
					payload: `organization=${organizationId}`,
				});
				return;
			}
		} else {
			dispatch({ type: LOAD_TEAMS });
			dispatch({
				type: SG_GET_SURVEY_STRUCTURES,
			});

			if (Number(EmployeeId) > 0) {
				dispatch({
					type: SG_GET_FILE_UPLOADS,
					payload: `file_type=3`
				});
			}
			return;
		}
		
	}, [dispatch, AmbassadorId, organizationId, EmployeeId]);

	useEffect(() => {
		dispatch({ 
			type: SG_GET_EMPLOYEE_RECORD_VALUE,
			// payload: `data_for=2&sort_order=1`
		});
	}, [dispatch]);


	useEffect(() => {
		if (Number(AmbassadorId) > 0) {
			setOrganizationId(get_selectedOrg?.organization?.id);
		} else {
			setOrganizationId(Number(get_auth.organization_id));
		}
	}, [get_selectedOrg, AmbassadorId, get_auth]);

	useEffect(() => {
		setEmployee(get_employee[EmployeeId]);
		if (get_employee[EmployeeId]?.account_type === 5) {
			setCreateEdit(true);
			return;
		}

		if (get_employee[EmployeeId]?.role < 7) {
			setCreateEdit(true);
			return;
		}
		setCreateEdit(false);
	}, [get_employee, EmployeeId]);

	useEffect(() => {
		if (get_errors?.status === 403) {
			setShowErrors(get_errors?.data?.detail);
		}
	}, [get_errors]);

	function clearErrors() {
		dispatch({
			type: CLEAR_ERRORS,
		});
		setShowErrors(false);
	}

	// console.log(get_survey_structure)
	// const DemoFile = () => {
	// 	saveAs(get_survey_structure?.[0]?.csv_template);
	// };
	function ResettoHomePage() {
		dispatch({
			type: CLOSE_FILE_UPLOAD,
			payload: showReportId,
		});
		setShowReportId(false)
		setShowPage(AllPageOptions[0])
	}

	const breadcrumbCrumbs = [
		{
			label: "Contact Update",
			onClick: () => ResettoHomePage(),
		},
	];
	if (showPage?.name && showPage?.id !== 1) {
		breadcrumbCrumbs.push({ label: showPage.name });
	}

	return (
		<PageContainer>
			<ContactBreadcrumb crumbs={breadcrumbCrumbs} />
			{/* Error Messages */}
			{showErrors && (
				<ErrorNotification>
					<ErrorHeader>
						<ErrorIcon>⚠</ErrorIcon>
						<ErrorText>
							<ErrorTitle>There was an error</ErrorTitle>
							<ErrorMessage>{showErrors}</ErrorMessage>
						</ErrorText>
					</ErrorHeader>
					<CloseButton onClick={clearErrors}>×</CloseButton>
				</ErrorNotification>
			)}

			{/* Page Header */}
			<PageHeader>
				<HeaderContent>
					<HeaderLeft>
						<PageTitle>{showPage?.name}</PageTitle>
						<PageDescription>
							{showPage?.id === 1 && "Manage your contact update files"}
							{showPage?.id === 2 && "Review update details and validation results"}
							{showPage?.id === 3 && "Upload a new CSV file to update contact data"}
						</PageDescription>
					</HeaderLeft>
					{showPage?.id > 1 && (
						<ClosePageButton onClick={ResettoHomePage}>
							<CloseIcon>×</CloseIcon>
							Close
						</ClosePageButton>
					)}
				</HeaderContent>
			</PageHeader>

			<BasicErrorMessage />

			{get_survey_structure?.[0]?.csv_template ? (
				<MainContent>
					{/* Upload New File Page */}
					{showPage?.id === 3 && (
						<FadeInContent>
							<Upload
								setFetchAgain={setFetchAgain}
								setShowReportId={setShowReportId}
								organizationId={organizationId}
								setShowPage={setShowPage}
								AllPageOptions={AllPageOptions}
							/>
						</FadeInContent>
					)}

					{/* Update Details Page */}
					{showPage?.id === 2 ? (
						<FadeInContent>
							{showReportId ? (
								<UpdateEmployeeRecordDetails
									showReportId={showReportId}
								/>
							) : (
								<EmptyState>
									<EmptyIcon>📁</EmptyIcon>
									<EmptyTitle>No update file selected</EmptyTitle>
									<EmptyDescription>
										Please select an update file from the list to view its details
									</EmptyDescription>
								</EmptyState>
							)}
						</FadeInContent>
					) : null}

					{/* Main Update List Page */}
					{showPage?.id === 1 && (
						<FadeInContent>
							<ActionBar>
								<ActionButton 
									variant="secondary"
									as={CSVLink}
									filename={"employee-record-upload.csv"}
									data={[employeeRecValue]}
								>
									<ButtonIcon>⬇</ButtonIcon>
									View Fields
								</ActionButton>
								<ActionButton 
									variant="primary" 
									onClick={() => setShowPage(AllPageOptions[2])}
								>
									<ButtonIcon>⬆</ButtonIcon>
									Upload File
								</ActionButton>
							</ActionBar>

							<List
								fetchAgain={fetchAgain}
								setFetchAgain={setFetchAgain}
								organizationId={organizationId}
								showErrors={showErrors}
								deletedRecord={deletedRecord}
								createEdit={createEdit}
								setDeletedRecord={setDeletedRecord}
								setShowReportId={setShowReportId}
								setShowPage={setShowPage}
								AllPageOptions={AllPageOptions}
							/>
						</FadeInContent>
					)}
				</MainContent>
			) : (
				<WarningCard>
					<WarningIcon>⚠</WarningIcon>
					<WarningContent>
						<WarningTitle>Survey structure required</WarningTitle>
						<WarningMessage>
							We were unable to find a matching survey structure. This information needs to be uploaded before we start the updates.
						</WarningMessage>
					</WarningContent>
				</WarningCard>
			)}
		</PageContainer>
	);
};

export default FileUploads;

// Main Container
const PageContainer = styled.div`
	background: white;
	font-family: "Poppins", sans-serif;
	min-height: 100vh;
	animation: fadeIn 0.3s ease-out;

	@keyframes fadeIn {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}
`;

// Page Header
const PageHeader = styled.div`
	background: white;
	border-bottom: 1px solid #e5e7eb;
	padding: 32px 48px;
`;

const HeaderContent = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	gap: 24px;
`;

const HeaderLeft = styled.div`
	flex: 1;
`;

const PageTitle = styled.h1`
	font-family: "Poppins", sans-serif;
	font-weight: 700;
	font-size: 28px;
	color: #1f2937;
	margin: 0 0 8px 0;
	line-height: 1.2;
`;

const PageDescription = styled.p`
	font-family: "Poppins", sans-serif;
	font-weight: 400;
	font-size: 16px;
	color: #6b7280;
	margin: 0;
	line-height: 1.5;
`;

const ClosePageButton = styled.button`
	background: transparent;
	color: #6b7280;
	border: none;
	border-radius: 6px;
	padding: 8px 16px;
	font-family: "Poppins", sans-serif;
	font-weight: 500;
	font-size: 14px;
	cursor: pointer;
	transition: all 0.2s ease;
	display: flex;
	align-items: center;
	gap: 6px;

	&:hover {
		color: #374151;
		background: #f9fafb;
	}
`;

const CloseIcon = styled.span`
	font-size: 18px;
	line-height: 1;
`;

// Error Notification
const ErrorNotification = styled.div`
	background: #fef2f2;
	border: 1px solid #fecaca;
	border-radius: 8px;
	padding: 16px;
	margin: 24px 48px;
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	animation: slideDown 0.3s ease-out;

	@keyframes slideDown {
		from {
			opacity: 0;
			transform: translateY(-10px);
		}
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}
`;

const ErrorHeader = styled.div`
	display: flex;
	align-items: flex-start;
	gap: 12px;
`;

const ErrorIcon = styled.div`
	color: #dc2626;
	font-size: 20px;
	line-height: 1;
	margin-top: 1px;
`;

const ErrorText = styled.div`
	flex: 1;
`;

const ErrorTitle = styled.div`
	font-weight: 600;
	font-size: 14px;
	color: #dc2626;
	margin-bottom: 4px;
`;

const ErrorMessage = styled.div`
	font-size: 14px;
	color: #7f1d1d;
	line-height: 1.4;
`;

const CloseButton = styled.button`
	background: transparent;
	border: none;
	color: #dc2626;
	font-size: 20px;
	cursor: pointer;
	padding: 0;
	width: 24px;
	height: 24px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 4px;
	transition: background-color 0.2s ease;

	&:hover {
		background: #fee2e2;
	}
`;

// Main Content
const MainContent = styled.div`
	padding: 32px 48px;
`;

const FadeInContent = styled.div`
	animation: contentFadeIn 0.4s ease-out;

	@keyframes contentFadeIn {
		from {
			opacity: 0;
			transform: translateY(8px);
		}
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}
`;

// Action Bar
const ActionBar = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 12px;
	margin-bottom: 32px;
`;

const ActionButton = styled.button`
	background: transparent;
	color: ${(props) => (props.variant === 'primary' ? '#476dfa' : '#6b7280')};
	border: none;
	border-radius: 6px;
	padding: 10px 16px;
	font-family: "Poppins", sans-serif;
	font-weight: ${(props) => (props.variant === 'primary' ? '600' : '500')};
	font-size: 14px;
	cursor: pointer;
	transition: all 0.2s ease;
	display: flex;
	align-items: center;
	gap: 8px;
	text-decoration: none;

	&:hover {
		color: ${(props) => (props.variant === 'primary' ? '#3d5ce6' : '#374151')};
		transform: translateY(-1px);
	}

	&:active {
		transform: translateY(0);
	}
`;

const ButtonIcon = styled.span`
	font-size: 16px;
	line-height: 1;
`;

// Empty State
const EmptyState = styled.div`
	text-align: center;
	padding: 64px 24px;
	color: #6b7280;
`;

const EmptyIcon = styled.div`
	font-size: 48px;
	margin-bottom: 16px;
	opacity: 0.6;
`;

const EmptyTitle = styled.h3`
	font-weight: 600;
	font-size: 18px;
	color: #374151;
	margin: 0 0 8px 0;
`;

const EmptyDescription = styled.p`
	font-size: 14px;
	color: #6b7280;
	margin: 0;
	line-height: 1.5;
`;

// Warning Card
const WarningCard = styled.div`
	background: #fef3c7;
	border: 1px solid #fcd34d;
	border-radius: 8px;
	padding: 20px;
	margin: 32px 48px;
	display: flex;
	align-items: flex-start;
	gap: 16px;
	animation: slideUp 0.3s ease-out;

	@keyframes slideUp {
		from {
			opacity: 0;
			transform: translateY(10px);
		}
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}
`;

const WarningIcon = styled.div`
	color: #f59e0b;
	font-size: 24px;
	line-height: 1;
	margin-top: 2px;
`;

const WarningContent = styled.div`
	flex: 1;
`;

const WarningTitle = styled.div`
	font-weight: 600;
	font-size: 16px;
	color: #92400e;
	margin-bottom: 8px;
`;

const WarningMessage = styled.div`
	font-size: 14px;
	color: #92400e;
	line-height: 1.5;
`;
